export default __webpack_public_path__ + "static/media/Pegasystems.2d99d67a.png";